import {athubAxios} from '../../util'
import {COMMON_SERVER} from '../server'
import {AuthInfo} from '@/util/user/authInfo';

import _ from 'lodash'

import {addParamsToUrl} from "../../util/common";

const CommonServiceApi = {

    getRoomsByAuthSites() {
        return new Promise((resolve, reject) => {
                athubAxios.postByMultipartForm(`${COMMON_SERVER}/sys/room/getSysRoomList`, {
                appId: 'WEB',
                token: localStorage.getItem('token'),
            }).then((res) => {
                if (res.data != null) {
            resolve(res.data);
        } else {
            reject('获取数据中心失败');
        }
    }, (error) => {
            reject(error);
        });
    });
    },
    getSysuserList(dcnum) {
        return new Promise((resolve, reject) => {
                athubAxios.postByMultipartForm(`${COMMON_SERVER}/sys/room/getSysuserList`, {
                appId: 'WEB',
                token: localStorage.getItem('token'),
                'dcnum':dcnum
            }).then((res) => {
                if (res.data != null) {
            resolve(res.data);
        } else {
            reject('获取数据中心失败');
        }
    }, (error) => {
            reject(error);
        });
    });
    },
};


export default CommonServiceApi;
